<template>
    <div id="TouchId" class=" flex">
        <div class="pieceBox flex">
             <div class="piece-item " v-for="(item,index) in list" :class="getClassesForIndex(index)"
             @click="opentouchDetail(item)"
             >
                <img :src="item.logo" alt="" v-if="item.logo">
                <div v-else class="imgReserve">
                    <i class="el-icon-picture"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getListScreen,getScreenDetail} from "@/api/enterprise/index"   
export default {
    name:'enTouch',
    data () {
        return {
            list:[],
        }
    },
    created () {
        document.title = '触摸内容'
        this.getTouchList()
    },
    methods: {
        // 打开详情
        opentouchDetail(data){
            let Url = ''
            if(data.contentType == 1 && data.detailId){
                if(data.websiteType !=4){
                    let nameString = ['','endowloadDetail','enCaseDetail','enSolution',]
                    Url = nameString[data.websiteType]
                this.$router.push(
                        {
                        name:Url,
                        query:{
                            id:data.detailId,
                            type:1
                        }
                        }
                        )
                 }else{
                     this.getdetail(data.id)
                 }
                
            }else{
            this.$router.push(
            {
            name:'enTouchDetail',
             query:{
                id:data.id
            }
            }
            )
            }
        },
        getdetail(id){
            getScreenDetail({id:id})
            .then(res =>{
                if(res.data.detailVO.type == 2){
                     let path=res.data.detailVO.content
                        window.open(path,'_black')
                }else{
                this.$router.push(
                    {
                    name:'enNewsDetail',
                    query:{
                        id:res.data.detailVO.id
                    }
                    }
                    )
                }
            })
        },
           // 根据索引展示不同样式
        getClassesForIndex(index){
            let classes = ''
             if (((index + 1) - 6) % 13 === 0) {
                
                    classes = `special-style-1`;
                }
              if(((index + 1) - 13) % 13 === 0){
                 classes = 'special-style-2';
              }
             return classes;
        },
        // 获取列表
        getTouchList(){
            getListScreen({id:this.$route.query.id})
            .then(res =>{
                this.list = res.data
            })
        },
    },
}
</script>
<style lang="scss" scoped>
#TouchId{
    width: 100%;
    background:#fff ;
            .pieceBox{
            max-width: 1500px;
            width: 100%;
            margin: 0 auto;
            flex-wrap: wrap;
            padding-top: 15px;
            padding-bottom: 15px;
            .piece-item{
                padding-bottom: 15px;
                width: 20%;
                text-align: center;
                position: relative;
                cursor: pointer;
                img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 285px;
                    max-height: 110px;
                    display: inline-block;
                     position: relative;
                }
                .imgReserve{
                    background: #f7f8fa;
                   
                    height: 110px;
                    text-align: center;
                    line-height: 110px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
             
                   .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 110px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 110px;
                        width: calc(100% - 15px);
                        max-width: 285px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 110px;
                            padding-right: 20px;
                        }
                    }
                }
            }
               .piece-item:hover{
                    .piece-item-mask{
                        display: block;
                    }
                }
            .special-style-1{
                width: 40%;
                 text-align: center;
                   img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 585px;
                    max-height: 110px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 110px;
                    text-align: center;
                    line-height: 110px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                  .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 110px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 110px;
                        width: calc(100% - 15px);
                        max-width: 585px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 110px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-2{
                 width: 40%;
                 text-align: center;
                    img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 585px;
                    max-height: 110px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 110px;
                    text-align: center;
                    line-height: 110px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
            }
        }
}
    @media (min-width: 1920px) {
        .pieceBox{
            max-width: 2000px;
            margin: 0 auto;
            flex-wrap: wrap;
            padding-top: 15px;
            // justify-content: space-between;
            .piece-item{
                padding-bottom: 15px;
                width: 20%;
                text-align: center;
                position: relative;
                img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 385px;
                    max-height: 200px;
                    display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                   
                    height: 200px;
                    text-align: center;
                    line-height: 200px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                   .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 200px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 200px;
                        width: calc(100% - 15px);
                        max-width: 385px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 200px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-1{
                width: 40%;
                 text-align: center;
                   img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 785px;
                    max-height: 200px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 200px;
                    text-align: center;
                    line-height: 200px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                    .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 200px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 200px;
                        width: calc(100% - 15px);
                        max-width: 785px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 200px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-2{
                 width: 40%;
                 text-align: center;
                    img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 785px;
                    max-height: 200px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 200px;
                    text-align: center;
                    line-height: 200px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
            }
        }
    }
    @media (min-width: 3000px) {
         .pieceBox{
            margin: 0 auto;
            flex-wrap: wrap;
            padding-top: 15px;
            .piece-item{
                padding-bottom: 15px;
                width: 20%;
                text-align: center;
                position: relative;
                img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-height: 300px;
                    display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                   
                    height: 300px;
                    text-align: center;
                    line-height: 300px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                 .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 300px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 300px;
                        width: calc(100% - 15px);
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 300px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-1{
                width: 40%;
                 text-align: center;
                   img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-height: 300px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 300px;
                    text-align: center;
                    line-height: 300px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                     .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 300px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 300px;
                        width: calc(100% - 15px);
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 300px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-2{
                 width: 40%;
                 text-align: center;
                    img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-height: 300px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 300px;
                    text-align: center;
                    line-height: 300px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
            }
        }
    }
</style>